export const normalizeProjects = (projects: any[]) =>
  projects.map((project: any) => ({
    ...project,
    files: project.files.map((file: any) => (file.response ? file.response : file)),
  })) as Project[];
export const normalizeReadingts = (readings: any[]) =>
  readings.map((reading: any) => ({
    ...reading,
    files: reading.files.map((file: any) => (file.response ? file.response : file)),
  })) as Reading[];

export const normalizeDocuments = (documents: any[]) =>
  documents.map((document: any) => {
    delete document.id;
    return {
      ...document,
      file: document.file.response ? document.file.response : document.file,
    };
  }) as Partial<UserDocument>[];

export const normalizeMedia = (media: any[]) =>
  media.map((mediaItem: any) => {
    delete mediaItem.id;
    if (mediaItem.file) {
      return {
        ...mediaItem,
        file: mediaItem.file?.[0]?.response ? mediaItem.file[0].response : mediaItem.file[0],
      };
    }
    return mediaItem;
  }) as Partial<UserDocument>[];
